/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import React from "react";

import { ModalBase } from "../../utils/Interfaces";

import { Typography, Modal, Backdrop, Fade, Box, Tooltip, IconButton } from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

export interface InfoModalProps extends ModalBase {
    title: string;
    description: string;
}

const InfoModal = (props: InfoModalProps) => {
    const { title, description, open, handleClose } = props;

    return (
        <Modal
            sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
            }}
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        minWidth: "400px",
                        maxWidth: "80vw",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "flex-start",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                pt: 1,
                                pl: 2,
                            }}
                        >
                            <Typography variant="h6">{title}</Typography>
                            <Box
                                sx={{
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                }}
                            >
                                <Tooltip title="Close">
                                    <IconButton onClick={() => handleClose()} size="large">
                                        <CloseIcon />
                                    </IconButton>
                                </Tooltip>
                            </Box>
                        </Box>
                        <Box marginBottom={"20px"} />
                        <Typography sx={{ margin: "14px" }}>{description}</Typography>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
};

export default InfoModal;
